import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import './assets/app.scss';
import 'grapp/dist/grapp.css';
import inputFilter from './directives/input-filter';

const VueCookie = require('vue-cookie');

Vue.use(Vuelidate);
Vue.use(VueCookie);
Vue.directive('input-filter', inputFilter);

Vue.config.productionTip = false;

new Vue({
  router,
  render(h) { return h(App); },
}).$mount('#app');
